import { render, staticRenderFns } from "./GetTransactionsUser.vue?vue&type=template&id=ef6636ba&scoped=true&"
import script from "./GetTransactionsUser.vue?vue&type=script&lang=js&"
export * from "./GetTransactionsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6636ba",
  null
  
)

export default component.exports